import React from 'react';
import { useParams } from '@tanstack/react-router';
import { Banner, EmptyState, LoadingOrbit, Page } from '@chatsdet/ui';
import { Robot } from '@phosphor-icons/react';
import { ApiError } from '../../../lib/api-error';
import { useAgentEvalRun } from '../../../features/agent-evals/useAgentEvalRun';
import { AgentEvalRunView } from './AgentEvalRunView';

export function AgentEvalRunPage() {
  const { runId } = useParams({ from: '/agent-evals/runs/$runId' });
  const query = useAgentEvalRun(runId);
  const run = query.data;

  if (query.isLoading) {
    return (
      <Page>
        <div className="flex items-center justify-center py-12">
          <LoadingOrbit size="lg" />
        </div>
      </Page>
    );
  }
  if (!run && query.isError && !(query.error instanceof ApiError && query.error.status === 404)) {
    return (
      <Page>
        <Banner variant="error">{query.error.message}</Banner>
      </Page>
    );
  }
  if (!run) {
    return (
      <Page>
        <EmptyState icon={<Robot size={48} />} title="Run not found" description="This eval run does not exist." />
      </Page>
    );
  }
  return <AgentEvalRunView run={run} />;
}
